function fun(doc, win) {
	var docEl = doc.documentElement,
		resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
		recalc = function() {
			var clientWidth = docEl.clientWidth;
			if (!clientWidth) return;

			// 1. 全局字体设置：如果宽度大于1200px，根字体大小为100px；否则，根据屏幕宽度缩放
			// if (clientWidth > 1200) {
			// 	docEl.style.fontSize = '100px'; // 设置固定的根字体大小
			// } else {
			docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px'; // 根据屏幕宽度进行缩放
			// }
		};

	// Abort if browser does not support addEventListener
	if (!doc.addEventListener) return;

	// 监听 resize 事件和 DOMContentLoaded 事件，调用 recalc 函数进行字体调整
	win.addEventListener(resizeEvt, recalc, false);
	doc.addEventListener('DOMContentLoaded', recalc, false);
}

fun(document, window);